const serialCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

/**
 * Natural sort for serial-like values.
 *
 * Examples: 1 < 2 < 10, A2 < A10, SN-2 < SN-10.
 */
export function compareSerialValues(a: string, b: string): number {
  return serialCollator.compare(a, b);
}

/**
 * Compares two items by serial value, then by a stable tie-breaker.
 */
export function compareBySerialWithTieBreaker(
  aSerial: string,
  bSerial: string,
  aTieBreaker: string,
  bTieBreaker: string,
): number {
  const serialCompare = compareSerialValues(aSerial, bSerial);
  if (serialCompare !== 0) {
    return serialCompare;
  }
  return aTieBreaker.localeCompare(bTieBreaker);
}
